// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"3c1baec2","232":"3366b28a","237":"190fb6ec","357":"418c961b","526":"7351a7ce","753":"cbab245a","854":"14245cea","872":"6896fdc7"}[chunkId] + ".chunk.js";
};